export enum DateRangeOption {
  TODAY = "TODAY",
  THIS_WEEK = "THIS_WEEK",
  THIS_MONTH = "THIS_MONTH",
  CUSTOM = "CUSTOM"
}

export enum TimeFrameChart {
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
  YEAR = "YEAR"
}

export enum TransactionTypeChart {
  PAYMENT_METHOD = "PAYMENT_METHOD",
  STATUS = "STATUS",
  OPERATION_TYPE = "OPERATION_TYPE",
  CARD_BRAND = "CARD_BRAND"
}
